;(() => {
  const SLIDE_DURATION = 5000;

  const playVideo = (slider) => {
    if (slider.swiper) {
      const sliderSwiper = slider.swiper;
      if (sliderSwiper.slides[sliderSwiper.previousIndex]) {
        const videoPrev = sliderSwiper.slides[sliderSwiper.previousIndex].querySelector('.slideshow__video video');
        if (videoPrev) videoPrev.pause();
      }
      if (sliderSwiper.slides[sliderSwiper.activeIndex]) {
        const videoActive = sliderSwiper.slides[sliderSwiper.activeIndex].querySelector('.slideshow__video video');
        if (videoActive) videoActive.play();
      }
    }
  };

  const stopVideo = (slider) => {
    if (slider.swiper) {
      const sliderSwiper = slider.swiper;
      if (sliderSwiper.slides[sliderSwiper.activeIndex]) {
        const videoActive = sliderSwiper.slides[sliderSwiper.activeIndex].querySelector('.slideshow__video video');
        if (videoActive) videoActive.pause();
      }
    }
  };

  /* === PROGRESS BAR LOGIC === */
  const progressTimers = {};

  function resetProgress($bars, $fills, swiperKey) {
    if (progressTimers[swiperKey]) {
      clearTimeout(progressTimers[swiperKey]);
      delete progressTimers[swiperKey];
    }
    $bars.removeClass('is-active');
    $fills.each(function () {
      this.style.transition = 'none';
      this.style.width = '0';
    });
  }

  function startProgress($bars, $fills, swiper, swiperKey) {
    resetProgress($bars, $fills, swiperKey);
    const realIdx = swiper.realIndex || 0;
    $bars.eq(realIdx).addClass('is-active');
    const $fill = $fills.eq(realIdx);
    if (!$fill.length) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        $fill[0].style.transition = 'width ' + SLIDE_DURATION + 'ms linear';
        $fill[0].style.width = '100%';
      });
    });

    progressTimers[swiperKey] = setTimeout(function () {
      delete progressTimers[swiperKey];
      try { if (swiper && !swiper.destroyed) swiper.slideNext(); } catch (e) {}
    }, SLIDE_DURATION);
  }

  function pauseProgress($fills) {
    $fills.each(function () {
      const w = getComputedStyle(this).width;
      this.style.transition = 'none';
      this.style.width = w;
    });
  }

  function resumeProgress($bars, $fills, swiper, swiperKey) {
    const realIdx = swiper.realIndex || 0;
    const $fill = $fills.eq(realIdx);
    if (!$fill.length) return;
    const currentW = parseFloat(getComputedStyle($fill[0]).width);
    const totalW = parseFloat(getComputedStyle($fill[0].parentElement).width);
    const remaining = totalW > 0 ? ((totalW - currentW) / totalW) * SLIDE_DURATION : SLIDE_DURATION;
    const clamped = Math.max(remaining, 0);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        $fill[0].style.transition = 'width ' + clamped + 'ms linear';
        $fill[0].style.width = '100%';
      });
    });

    if (progressTimers[swiperKey]) clearTimeout(progressTimers[swiperKey]);
    progressTimers[swiperKey] = setTimeout(function () {
      delete progressTimers[swiperKey];
      try { if (swiper && !swiper.destroyed) swiper.slideNext(); } catch (e) {}
    }, clamped + 50);
  }

  const initSlider = (section) => {
    let parent;
    if (document.currentScript) {
      parent = document.currentScript.parentElement;
    } else {
      parent = section;
    }

    const slideshow = parent.querySelector('.slideshow__swiper');
    const prevBtn = parent.querySelector('.swiper-button-prev');
    const nextBtn = parent.querySelector('.swiper-button-next');
    const progressEl = parent.querySelector('.slideshow__progress');
    const thumbs = parent.querySelector('.slideshow__thumbs');
    const thumbsFull = parent.querySelector('.slideshow__thumbs-full');

    const swiperKey = slideshow && slideshow.closest('[id]') ? slideshow.closest('[id]').id : 'slideshow-' + Math.random().toString(36).slice(2, 8);

    if (slideshow) {
      const countSlides = slideshow.querySelectorAll('.slideshow__slide').length;

      let thumbsSwiper;
      if (thumbs) {
        let slidesPerView990 = countSlides < 4 ? countSlides : 4;
        let slidesPerView750 = countSlides < 4 ? slidesPerView990 : 3;
        let slidesPerView576 = countSlides < 3 ? slidesPerView750 : 2;
        let slidesPerView = countSlides < 2 ? slidesPerView576 : 1.8;
        let swiperThumbsParams = {
          slidesPerView: slidesPerView,
          mousewheel: { forceToAxis: true },
          spaceBetween: 8,
          breakpoints: {
            576: { slidesPerView: slidesPerView576, spaceBetween: 20 },
            750: { slidesPerView: slidesPerView750, spaceBetween: 20 },
            990: { slidesPerView: slidesPerView990, spaceBetween: 20 }
          },
          on: {
            touchEnd: function (s, e) {
              let range = 5;
              let diff = (s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY);
              if (diff < range || diff > -range) s.allowClick = true;
            }
          }
        };
        thumbsSwiper = new Swiper(thumbs, swiperThumbsParams);
      }

      let thumbsFullSwiper;
      if (thumbsFull) {
        let slidesPerView990 = countSlides < 4 ? countSlides : 4;
        let slidesPerView750 = countSlides < 4 ? slidesPerView990 : 3;
        let slidesPerView576 = countSlides < 3 ? slidesPerView750 : 2;
        let slidesPerView = countSlides < 2 ? slidesPerView576 : 1.8;
        let swiperThumbsParams = {
          slidesPerView: slidesPerView,
          mousewheel: { forceToAxis: true },
          spaceBetween: 24,
          breakpoints: {
            576: { slidesPerView: slidesPerView576, spaceBetween: 32 },
            750: { slidesPerView: slidesPerView750, spaceBetween: 48 },
            990: { slidesPerView: slidesPerView990, spaceBetween: 64 }
          },
          on: {
            touchEnd: function (s, e) {
              let range = 5;
              let diff = (s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY);
              if (diff < range || diff > -range) s.allowClick = true;
            }
          }
        };
        thumbsFullSwiper = new Swiper(thumbsFull, swiperThumbsParams);
      }

      let swiperParams = {
        speed: 700,
        mousewheel: { forceToAxis: true },
        autoHeight: false,
        allowTouchMove: true,
        on: {
          slideChange() { playVideo(slideshow); }
        }
      };

      if (slideshow.getAttribute('data-autoplay') === 'true') {
        swiperParams.autoplay = {
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        };
      }

      if (slideshow.getAttribute('data-loop') === 'true') {
        swiperParams.loop = true;
        swiperParams.loopPreventsSliding = false;
      }

      if (slideshow.getAttribute('data-navigation') === 'true') {
        swiperParams.navigation = { nextEl: nextBtn, prevEl: prevBtn };
      }

      if (slideshow.getAttribute('data-parallax') === 'true') {
        swiperParams.parallax = true;
      }

      const $bars = $(progressEl).find('.slideshow__progress-bar');
      const $fills = $(progressEl).find('.slideshow__progress-fill');

      if (progressEl && $bars.length > 1) {
        // On slide change: update progress bar
        swiperParams.on.slideChangeTransitionEnd = function () {
          playVideo(slideshow);
        };
        swiperParams.on.slideChange = function () {
          // Reset all then start active
          $bars.removeClass('is-active');
          $fills.each(function () { this.style.transition = 'none'; this.style.width = '0'; });
        };
      }

      if (slideshow.getAttribute('data-pagination') === 'true') {
        switch (slideshow.getAttribute('data-pagination-type')) {
          case 'tabs':
            swiperParams.thumbs = { swiper: thumbsSwiper };
            break;
          case 'tabs_full':
            swiperParams.thumbs = { swiper: thumbsFullSwiper };
            break;
        }
      }

      const slideshowSwiper = new Swiper(slideshow, swiperParams);

      /* === PROGRESS BAR SETUP === */
      if (progressEl && $bars.length > 1 && slideshow.getAttribute('data-autoplay') === 'true') {
        // Start progress for first slide
        startProgress($bars, $fills, slideshowSwiper, swiperKey);

        // On slide change transition end, start new progress
        slideshowSwiper.on('slideChangeTransitionEnd', function () {
          startProgress($bars, $fills, this, swiperKey);
        });

        // Click on progress bar to navigate
        $bars.on('click', function () {
          const i = parseInt($(this).attr('data-i'), 10) || 0;
          if (slideshowSwiper.slideToLoop) slideshowSwiper.slideToLoop(i);
          else slideshowSwiper.slideTo(i);
        });

        // Hover: pause progress
        slideshow.addEventListener('mouseenter', function () {
          pauseProgress($fills);
          if (progressTimers[swiperKey]) {
            clearTimeout(progressTimers[swiperKey]);
            delete progressTimers[swiperKey];
          }
        });

        slideshow.addEventListener('mouseleave', function () {
          resumeProgress($bars, $fills, slideshowSwiper, swiperKey);
        });
      }
    }
  };

  const initSection = (section) => {
    let sectionSlideshow;
    if (document.currentScript) {
      sectionSlideshow = document.currentScript.parentElement;
    } else {
      sectionSlideshow = section;
    }

    if (sectionSlideshow) {
      const slider = sectionSlideshow.querySelector('.slideshow__swiper');
      const progressEl = sectionSlideshow.querySelector('.slideshow__progress');

      const sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (slider) {
              playVideo(slider);
              if (slider.swiper && slider.getAttribute('data-autoplay') === 'true')
                slider.swiper.autoplay.resume();
            }
          } else {
            if (slider) {
              stopVideo(slider);
              if (slider.swiper && slider.getAttribute('data-autoplay') === 'true')
                slider.swiper.autoplay.pause();
            }
          }
        });
      });

      const sectionResizeObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        if (slider && slider.swiper) {
          slider.swiper.update();
        }
      });

      sectionObserver.observe(sectionSlideshow);
      sectionResizeObserver.observe(sectionSlideshow);
    }
  };

  initSlider();
  initSection();

  document.addEventListener('shopify:section:load', function (section) {
    initSlider(section.target);
    initSection(section.target);
  });
})();
